import { ChatResponseOption } from '@akin-home/chat';
import { Text } from '@akin-home/text/native';
import { colors } from '@akin-home/theme';
import { useMemo } from 'react';
import styled from 'styled-components/native';
import { OptionCheckbox } from './OptionCheckbox';

type Props = {
  options: ChatResponseOption[];
  onPressOption(option: ChatResponseOption): void;
};

export function Options(props: Props) {
  const { options } = props;

  const columns = useMemo(() => {
    if (options.length <= 4) {
      return [options];
    } else {
      return splitArrayIntoTwoHalves(options);
    }
  }, [options]);

  return (
    <OptionColumns>
      {columns.map((col, idx) => (
        <OptionsList key={idx}>
          {col.map((option, idx) => (
            <Option
              key={option.label + idx}
              option={option}
              selected={option.selected}
              onPress={props.onPressOption}
            />
          ))}
        </OptionsList>
      ))}
    </OptionColumns>
  );
}

type OptionProps = {
  option: ChatResponseOption;
  selected?: boolean;

  onPress(option: ChatResponseOption): void;
};

function Option(props: OptionProps) {
  const { option, selected } = props;

  function onPress() {
    props.onPress?.(option);
  }

  return (
    <OptionContainer selected={selected} onPress={onPress}>
      <Text>{option.label}</Text>
      <OptionCheckbox checked={selected} />
    </OptionContainer>
  );
}

const OptionsList = styled.View`
  flex: 1 0 40%;
  gap: 12px;
`;

const OptionColumns = styled.View`
  flex-direction: row;
  gap: 12px;
`;

export const OptionContainer = styled.TouchableOpacity<{
  selected?: boolean;
  color?: string;
}>`
  padding: 16px;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-width: 1px;
  border-radius: 20px;
  border-color: ${({ color }) => color ?? 'lightgrey'};

  ${({ selected, color }) =>
    selected &&
    `
    border-color: ${color ?? colors.primary[70]};
    background-color: ${color ?? '#F6F7F9'};
`}
`;

function splitArrayIntoTwoHalves<T>(array: T[]) {
  const length = array.length;
  const middleIndex = Math.round(length / 2);
  const firstHalf = array.slice(0, middleIndex);
  const secondHalf = array.slice(middleIndex);
  return [firstHalf, secondHalf];
}
